
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.705 8.516a6.545 6.545 0 0012.718 2.182M2.705 8.516l2.181 1.455M2.705 8.516L1.25 10.698m14.546-2.91A6.545 6.545 0 003.077 5.608m12.719 2.182l-2.182-1.455m2.181 1.455l1.455-2.182","stroke":"#56BFC7","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    